"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpperChineseNumberString = exports.LowerChineseNumberString = exports.NumberLanguageCaseType = void 0;
/**
 * 大小写类型
 */
var NumberLanguageCaseType;
(function (NumberLanguageCaseType) {
    NumberLanguageCaseType["Default"] = "0";
    NumberLanguageCaseType["ChineseLowerCase"] = "1";
    NumberLanguageCaseType["ChineseUpperCase"] = "2";
})(NumberLanguageCaseType = exports.NumberLanguageCaseType || (exports.NumberLanguageCaseType = {}));
/**
 * 小写中文数字
 */
exports.LowerChineseNumberString = {
    cnNums: ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
    cnIntRadice: ['', '十', '百', '千'],
    cnIntUnits: ['', '万', '亿', '兆'],
};
/**
 * 大写中文数字
 */
exports.UpperChineseNumberString = {
    cnNums: ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
    cnIntRadice: ['', '拾', '佰', '仟'],
    cnIntUnits: ['', '万', '亿', '兆'],
};
//# sourceMappingURL=language-const.js.map